import { render, staticRenderFns } from "./my-exchange.vue?vue&type=template&id=1f45075a&"
import script from "./my-exchange.vue?vue&type=script&lang=js&"
export * from "./my-exchange.vue?vue&type=script&lang=js&"
import style0 from "./my-exchange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports